export default function getResource(label, vars = []) {
    const resources = {
        title: 'Cette vitrine n’est pas disponible dans votre région pour le moment.',
        subTitle: 'Cette page n’est accessible qu’aux États-Unis pour le moment.',
        ctaText: 'Continuer à magasiner',
        linkText: 'Consultez les sites Web de Sephora International'
    };

    return resources[label];
}
